import styled from "styled-components";

export const CMInputPassword = styled.div(props => ({
    position: 'relative',
    marginBottom:0,

    'span': {
        top: '0.5rem',
        right: -1,
        height: 'calc(100% - 1.5rem)',
        maxHeight: 'calc(100% - 1.5rem)',
        minHeight: 'calc(100% - 2.8rem)',
        width: '2.5rem',
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        backgroundColor: props.theme.palette.primary.main,
        [`@media (min-width: 2000px)`]: {
            width: '6vh',
            minHeight: 'calc(100% - 2.4rem)',
        },
    },
}));